<template>
    <div>
        <top-navbar></top-navbar>
<div>
  

<div class=" mb-5 background_color">
  <h6 class="manage-boder pt-2 font1  decoration"><router-link class="decoration" to="/issuetracking/index"> {{language[1]['Home']}} </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>  Allocate Issue Tracking</h6>
 
  <!-- <h6 class="custom-maintitle "><b>Issue Tracking</b></h6> -->
  <b-modal :id="infoModal2.id" 
   @shown="initContractorMap"
   size="xl" hide-footer
    class="top-modal">
   <div>
    <div id="contractor-map" class="issue-map-container"></div>
   </div>

  </b-modal>

  <div class="container-fluid">
      <div style="border: 0px; padding: 0px; min-height:0px" class="navbar background_color">

        <div class="d-flex">
          <b-input-group size="sm" style="width: 225px;">
            <b-form-input id="filter-input" v-model="filter" type="search" placeholder="Search">
            </b-form-input>
            
    </b-input-group>
    <div style="margin-top: 11px;" class="ms-2" >
    <span class="custom-breadcrumb"><b>{{language[11]['Showing']}} {{currentPage}}-{{currentPage*perPage}}  {{language[12]['of']}}{{totalRows}} {{language[13]['items']}}.</b></span>
  </div>

        </div>
  




      
</div>

<div>

<b-modal :id="infoModal1.id" 
     :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant"
      size="sm" hide-footer
     bottom>
    <template  #modal-title>
     
      <h5 > {{language[39]['Comment']}}</h5>


    </template>
    
   <div>
    <table class="table table-sm table-borderless">
      <tbody>
        <tr>
       
        <td> <textarea class="form-control font-size_def" v-model="comment" rows="3"></textarea></td>
        
        </tr>

       
      </tbody>
      
    </table>
      
   

   </div>
   <div style="margin-right: -18px;" class="modal-footer">
      
      <button type="button" @click="commentSubmit(infoModal1.content)"
       class=" btn btn-sm btn-outline-primary bdr-rad"> {{language[93]['Add Comment']}}</button>
    </div>
  

  
  </b-modal>
</div>


<div class="card bdr-rad2 mt-1 shadow p-2 ">
<div class="card-body ">
 

  <b-table responsive style="font-size: small;"   class="table-hover"
      :items="issues"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
    
      :filter="filter"
      :filter-included-fields="filterOn"
      :sort-by.sync="sortBy"
        head-variant="dark"
      
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
  
      show-empty
      small
     
    >
   

    <!-- @filtered="onFiltered" -->
      <template #cell(name)="row">
        {{ row.value.first }} {{ row.value.last }}
      </template>

      <!-- <template #cell(map)="row">
        <button class="btn btn-sm btn-outline-primary  bdr-rad" type="button" >
    Link
  </button>
      </template> -->
  <template #cell(statusmy)="row">
        
        <div style="background-color: red;text-align: center;border-radius: 12px;padding: 4px;" v-show="row.item.status==1" >{{ row.item.status1 }} </div>
        <div style="background-color: #ee68f9;text-align: center;border-radius: 12px;padding: 4px;" v-show="row.item.status==42" >{{ row.item.status1 }} </div>
        <div  v-show="row.item.status==49" style="background-color: green;text-align: center;border-radius: 12px;padding: 4px;">{{ row.item.status1 }} </div>
      </template>

      <template #cell(actions)="row">

<div class="dropdown">
<button class="btn btn-sm btn-outline-primary dropdown-toggle bdr-rad" type="button" data-toggle="dropdown" aria-expanded="false">
  {{language[24]['Actions']}}
</button>
<div class="dropdown-menu bdr-rad">

<a class="dropdown-item mouse-cursor"@click="viewPage(row.item.id)"  >{{language[28]['View']}}</a>
<a class="dropdown-item mouse-cursor"@click="viewMap(row.item.id)"  >{{language[29]['View Map']}}</a>
<a class="dropdown-item mouse-cursor"    @click="addComment(row.item.id)"> {{language[93]['Add Comment']}}</a>

</div>
</div>
</template>

      <template #row-details="row">
        <b-card>
          <ul>
            <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
          </ul>
        </b-card>
      </template>
    </b-table>
    
      <b-col style="padding-left: 0px;" sm="7" md="2" class="my-1 mb-5">
        <b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" size="sm"></b-pagination>
      </b-col>

      

  
    
    

  
</div>
</div>
</div>
<br><br>
</div>









</div>






        
        <content-footer></content-footer>
    </div>
</template>
<script>
 import axios from 'axios';
 import httpClient from '@/axios';
 import vSelect from 'vue-select';
 import authService from '@/auth.service';
  import TopNavbar from './../../layout/TopNavbar.vue'
  import ContentFooter from './../../layout/ContentFooter.vue'

  const LEAFLET_CSS_URL = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
  const LEAFLET_JS_URL = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
  const LEAFLET_IMAGE_BASE_URL = 'https://unpkg.com/leaflet@1.9.4/dist/images/';

  export default {
    data() {
      return {
        access_token:authService.isLoggedIn(),
        userid:authService.isUserid(),
        language:JSON.parse(authService.isLanguage()),
        sortBy: '',
        count: 0,
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        filterOn: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 15,
        pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
        map: null, // Controls the visibility of the modal
      latitude: null, // Store latitude
      longitude: null,
        contractorMap: null,
        issues:[],
        contracs:[],
        comment:'',
        detail:[
      {},  
      ],
      fields: [],
      


        infoModal1: {
          id: 'info-modal1',
          title: '',
          content: [],
        },
        infoModal2: {
          id: 'info-modal2',
          title: '',
          content: [],
        },
      


        
      }

    },

    created(){
      this.loadIssue();
    },
 
    mounted(){
    
      this.fields= [
          { key: 'issue_no', label: this.language[14], sortable: true, sortDirection: 'desc' },
          { key: 'name1', label: this.language[15]['Citizen Name'], sortable: true,  },
          { key: 'main_category', label: this.language[16]['Main Category'], sortable: true  },
          { key: 'sub_category', label: this.language[17]['Sub Category'], sortable: true  },
          { key: 'mobile', label: this.language[18]['Citizen Mobile'], sortable: true  },
          { key: 'email', label: this.language[19]['Citizen Email'], sortable: true  },
          { key: 'statusmy', label: this.language[22]['Status'], sortable: true  },
          { key: 'created_date', label: this.language[23]['Created Date'], sortable: true  },
         
          
          { key: 'contr_name', label: this.language[80],  },
          { key: 'actions', label: this.language[24]['Actions'],  }
        ];
 


    },
methods : {

  loadLeaflet() {
    if (window.L) {
      return Promise.resolve(window.L);
    }

    if (window.issueTrackingLeafletPromise) {
      return window.issueTrackingLeafletPromise;
    }

    window.issueTrackingLeafletPromise = new Promise((resolve, reject) => {
      if (!document.querySelector(`link[href="${LEAFLET_CSS_URL}"]`)) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = LEAFLET_CSS_URL;
        document.head.appendChild(link);
      }

      const existingScript = document.querySelector(`script[src="${LEAFLET_JS_URL}"]`);
      const configureLeaflet = () => {
        if (!window.L) {
          reject(new Error('Leaflet did not initialize'));
          return;
        }

        delete window.L.Icon.Default.prototype._getIconUrl;
        window.L.Icon.Default.mergeOptions({
          iconRetinaUrl: `${LEAFLET_IMAGE_BASE_URL}marker-icon-2x.png`,
          iconUrl: `${LEAFLET_IMAGE_BASE_URL}marker-icon.png`,
          shadowUrl: `${LEAFLET_IMAGE_BASE_URL}marker-shadow.png`,
        });

        resolve(window.L);
      };

      if (existingScript) {
        existingScript.addEventListener('load', configureLeaflet, { once: true });
        existingScript.addEventListener('error', () => reject(new Error('Leaflet script failed to load')), { once: true });
        if (window.L) {
          configureLeaflet();
        }
        return;
      }

      const script = document.createElement('script');
      script.src = LEAFLET_JS_URL;
      script.defer = true;
      script.onload = configureLeaflet;
      script.onerror = () => reject(new Error('Leaflet script failed to load'));
      document.head.appendChild(script);
    });

    return window.issueTrackingLeafletPromise;
  },

  getMapMarkerIcon() {
    return window.L.divIcon({
      className: 'leaflet-red-marker-icon',
      html: '<span style="position:relative;display:block;width:26px;height:26px;background:#d93025;border:2px solid #fff;border-radius:50% 50% 50% 0;box-shadow:0 3px 8px rgba(0,0,0,.35);transform:rotate(-45deg);"><span style="position:absolute;top:7px;left:7px;width:8px;height:8px;background:#fff;border-radius:50%;"></span></span>',
      iconSize: [30, 42],
      iconAnchor: [15, 42],
      popupAnchor: [0, -38],
    });
  },

  async initContractorMap() {
    const lat = parseFloat(this.latitude);
    const lng = parseFloat(this.longitude);

    if (isNaN(lat) || isNaN(lng)) {
      return;
    }

    try {
      await this.loadLeaflet();
    } catch (error) {
      console.error('Leaflet failed to load', error);
      return;
    }

    const L = window.L;
    const mapDiv = document.getElementById('contractor-map');

    if (!mapDiv) {
      console.error('contractor-map div not found');
      return;
    }

    if (this.contractorMap) {
      this.contractorMap.remove();
      this.contractorMap = null;
    }

    mapDiv.innerHTML = '';
    if (mapDiv._leaflet_id) {
      mapDiv._leaflet_id = null;
    }

    this.contractorMap = L.map(mapDiv, {
      maxBounds: L.latLngBounds([55.005, 11.0274], [69.1062, 24.1553]),
      maxBoundsViscosity: 0.8,
    }).setView([lat, lng], 13);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap contributors',
      maxZoom: 19,
    }).addTo(this.contractorMap);

    L.marker([lat, lng], {
      icon: this.getMapMarkerIcon(),
    }).addTo(this.contractorMap).bindPopup('Location of the issue').openPopup();

    setTimeout(() => this.contractorMap.invalidateSize(), 100);
  },

  closeMap() {
    this.showMap = false;
    this.latitude = null;
    this.longitude = null; // Reset coordinates when closing the map
  },



  viewPage(id){
    this.$router.push('/issuetracking/contractorview?id='+id);
  },
  IssueCreate(){
    this.$router.push('/issuetracking/create');
  },

  loadIssue(id) {

this.filterOn = id;
  },

  async viewMap(id){


try {
  const { data} = await  httpClient.get('/web/api/issuetracking/loadmap?id='+id,{
    headers:{
      'Authorization':'Bearer '+this.access_token,
      'Content-type': 'application/json',
     
    }
   });
   console.log(data);
   if(data.status==200){
          this.latitude = data.lan;
          this.longitude = data.lng;
          this.infoModal2.content = id;
          this.$root.$emit('bv::show::modal', this.infoModal2.id);
         
   }
  
} catch (error) {
  console.log(error.response);
}

},


  async addComment(id){

    this.infoModal1.content = id;
    this.$root.$emit('bv::show::modal', this.infoModal1.id);
  

  },

  async commentSubmit(id) {
    
    try {
      const { data} = await  httpClient.post('/web/api/issuetracking/contractorcrmcreate?id='+id,
      {userid:this.userid,issues:this.issues,comment:this.comment},{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       if(data.status == 200){
        window.location.reload();
       }
        
      
    } catch (error) {
      console.log(error.response);
    }
  },
 

 
  async loadIssue() {
    console.log(this.userid);
    try {
      const { data} = await  httpClient.get('/web/api/issuetracking/contractorindex?id='+this.userid,{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
         this.issues = data.issues;
        this.totalRows =  this.issues.length;
      
    } catch (error) {
      console.log(error.response);
    }
  },



  add: function(){
            this.count++;
            this.detail.push({
             
            },)
           
        },

  remove: function () {
            this.count--;
            this.detail.splice({
              
            },1)
            
        },
   

       


 
  


 


},

    components :{
        ContentFooter,
        TopNavbar,
        'v-select': vSelect,
    },
  }

</script>
<style scoped>
.issue-map-container {
  width: 100%;
  height: 420px;
}

.leaflet-red-marker-icon {
  background: transparent;
  border: 0;
}

</style>
